/**
 * THE REQUEST EMAIL'S WORDS (note 01 E.3; research 01 §2.4; research 09 §8.3).
 *
 * Sent to every active administrator of a firm when support requests its move
 * to Cova BMS. It says what is being asked and links to the agreement page;
 * the full text is on the page, where the administrator reads it before
 * agreeing, so the email quotes the agreement's opening paragraph and nothing more.
 *
 * THE LINK CARRIES THE PATH ONLY. The settings guard's redirect drops the
 * query string (research 01 §2.3.4), so the page reads its state through its
 * own endpoint and needs nothing from the URL.
 *
 * BROWSER-SAFE: plain data. The react-email template renders it word for word.
 */
import { CURRENT_AGREEMENT_TEXT } from "./agreement-text"

/** The agreement page, the platform's own address as the billing notices write theirs. */
export const AGREEMENT_PAGE_PATH = "/settings/cutover"
export const AGREEMENT_PAGE_URL = `https://platform.cova.ai${AGREEMENT_PAGE_PATH}`

export interface MoveRequestEmailInput {
  /** The firm's display name; empty when it could not be read. */
  readonly orgName: string
}

export interface MoveRequestEmailCopy {
  readonly subject: string
  readonly heading: string
  readonly paragraphs: ReadonlyArray<string>
  readonly ctaLabel: string
  readonly ctaUrl: string
  readonly footer: string
}

export const moveRequestEmailCopy = ({ orgName }: MoveRequestEmailInput): MoveRequestEmailCopy => {
  const firm = orgName.trim() === "" ? "your firm" : orgName.trim()
  return {
    subject: `Action needed: agree to move ${firm}'s clients to Cova CRM`,
    heading: CURRENT_AGREEMENT_TEXT.title,
    paragraphs: [
      `Cova support has asked to move ${firm}'s clients from Clients (Legacy) to Cova CRM.`,
      CURRENT_AGREEMENT_TEXT.intro,
      "Open the agreement page to see which of your clients match clients already in Cova CRM, choose the scope and agree. Nothing moves until an administrator at your firm agrees.",
    ],
    ctaLabel: "Review and agree",
    ctaUrl: AGREEMENT_PAGE_URL,
    footer: "You are receiving this because you are an administrator of your firm on Cova.",
  }
}
